<template>
  <v-dialog v-model="dialog" width="400px" persistent>
    <v-card>
      <v-card-title class="pa-6"> Cập nhật lại các đầu điểm trong nhóm </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <div>Nhóm đầu điểm chứa các đầu điểm đã bị xoá.</div>
        <div>Bạn muốn giữ nguyên các đầu điểm cũ hay xoá hoàn toàn?</div>
      </v-card-text>
      <v-card-actions class="pa-6 pt-0">
        <BaseButton color="error" text="Xóa hoàn toàn" outlined @click="onDelete" :loading="loading" />
        <v-spacer />
        <BaseButton text="Giữ nguyên" @click="onRemain" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import BaseButton from '../../../../components/basic/BaseButton.vue'
export default {
  components: {BaseButton},
  data() {
    return {
      dialog: false,
      loading: false,
      children: [],
      groupId: '',
    }
  },
  methods: {
    ...mapActions({
      removeMarks: 'gradeMark/delete',
      deParent: 'gradeMark/deParent',
    }),
    openPopup({ children, id }) {
      this.children = children
      this.groupId = id
      this.dialog = true
    },
    closePopup() {
      this.dialog = false
      this.refresh()
    },
    refresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onDelete() {
      this.loading = true
      for (let i = 0; i < this.children.length; i++) {
        const child = this.children[i]
        await this.removeMarks(child.id)
        this.$emit('onRefresh')
      }
      this.$alert.success('Cập nhật đầu điểm trong nhóm thành công')
      this.loading = false
    },
    async onRemain() {
      try {
        await this.deParent({
          parent: this.groupId,
        })
        this.$alert.success('Cập nhật đầu điểm trong nhóm thành công')
        this.$emit('onRefresh')
        this.closePopup()
      } catch (error) {
        this.$alert.error(error)
      }
    },
  },
}
</script>
